module.exports = __webpack_public_path__ + "media/src/assets/Images/MessageSend-1346356fba505c531070c8667495e947.svg";